import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ConnecttocrudService} from '../../connecttocrud.service';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
import {ActivatedRoute, Router} from '@angular/router';
import {JsonEditorComponent} from 'ang-jsoneditor';
import {HeadersComponent} from '../../devex/headers/headers.component';
import {TestCaseNameInputDialog} from '../../testcase/testcase.component';
import {MatDialog} from '@angular/material';
import {ConfService} from '../../conf.service';
import {TestExecutorComponent} from '../test-executor/test-executor.component';

@Component({
    selector: 'app-presteps',
    templateUrl: './presteps.component.html',
    styleUrls: ['./presteps.component.scss']
})
export class PrestepsComponent implements OnInit {


    authModel = [];
    headersData = [];
    prerequisites = [];
    requestBody = {};
    formData = [];
    parameterData = [];
    pathParameter = [];
    responseData = [];
    errorMessage = '';
    responseError = '';
    responses: any;
    responseItems: any;
    requestBodySelected = '';
    @Output() onCompletingPreSteps: EventEmitter<any> = new EventEmitter<any>();
    @ViewChild(JsonEditorComponent) editor: JsonEditorComponent;
    @ViewChild(HeadersComponent) headerChild: HeadersComponent;
    httpOperation;
    httpUrl;
    httpOperations = [
        {'name': 'GET'},
        {'name': 'POST'},
        {'name': 'PUT'},
        {'name': 'PATCH'},
        {'name': 'DELETE'}
    ];
    preStepsList = [];
    preStepsSearchText = '';
    currentPreStepIndex: any;
    @Input() partner = localStorage.getItem('partner');
    @Input() account = localStorage.getItem('account');
    executor;
    executors;
    @Input() executor_name = '';
    @Input() executor_version = '';
    @Input() editFlag: boolean;
    executor_type;
    executor_method_type;
    formDataTrue;
    formURLEncodedTrue;
    rawRequestBody;
    private devExURL: any;
    private pathParameterSegregator: any;
    private pathParameterStopper: any;
    private pathParameterValue: any;
    private find: any;
    private showPathParameters: any;


    constructor(private _service: ConnecttocrudService, public platform: LeftpanelComponent, private route: ActivatedRoute, public dialog: MatDialog, public router: Router, private confPost: ConfService, public testExecutor: TestExecutorComponent) {
    }

    ngOnInit() {

        this.confPost.getApiExecutorsForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).toPromise().then(res => {
            this.executors = res;
        });

        // this.confPost.getApiExecutorByPartnerAccountByNameAndVersion(this.partner, this.account, this.getEntity(item), this.getVersion(item)).subscribe(exec => {
        //     this.executor = exec;
        //     this.httpUrl = this.executor.apiUrl;
        //     this.executor_name = this.executor.executor_name;
        //     this.executor_version = this.executor.executor_version;
        //     this.executor_type = this.executor.executor_type;
        //     this.executor_method_type = this.executor.executor_method_type;
        //     this.httpOperation = this.executor.executor_method_type;
        //     this.parameterData = this.executor.queryParams;
        //     this.pathParameter = this.executor.pathParams;
        //     this.authModel = this.executor.authModel;
        //     this.headersData = this.executor.headers;
        //     for (const header of this.headersData) {
        //         if (header['key'] === 'Content-Type') {
        //             switch (header['value']) {
        //                 case 'multipart/form-data':
        //                     this.requestBodySelected = 'form-data';
        //                     this.formData = this.executor.requestBody.value;
        //                     this.formDataTrue = true;
        //                     this.formURLEncodedTrue = false;
        //                     break;
        //                 case 'application/x-www-form-urlencoded':
        //                     this.requestBodySelected = 'x-www-form-urlencoded';
        //                     this.formData = this.executor.requestBody.value;
        //                     this.formDataTrue = false;
        //                     this.formURLEncodedTrue = true;
        //                     break;
        //                 case 'application/json':
        //                     this.requestBodySelected = 'raw';
        //                     this.rawRequestBody = this.executor.requestBody.value;
        //                     break;
        //                 default:
        //                     this.requestBodySelected = 'none';
        //                     break;
        //             }
        //         }
        //     }
        //     this.requestBody = this.executor.requestBody;
        //     // this.executors = this.executor.executors;
        //     // if (this.executor.responseAttributes !== null) {
        //     //     this.apiByDefinition = this.executor.responseAttributes;
        //     // }
        // });


        // for (const header of this.headersData) {
        //     if (header['key'] === 'Content-Type') {
        //         switch (header['value']) {
        //             case 'multipart/form-data':
        //                 this.requestBodySelected = 'form-data';
        //                 break;
        //             case 'application/x-www-form-urlencoded':
        //                 this.requestBodySelected = 'x-www-form-urlencoded';
        //                 break;
        //             case 'application/json':
        //                 this.requestBodySelected = 'raw';
        //                 break;
        //             default:
        //                 this.requestBodySelected = 'none';
        //                 break;
        //         }
        //     }
        // }
    }


    parameterDataCheck(event: any) {
        // /: calculation
        if (this.devExURL !== event.target.value) {
            this.devExURL = event.target.value;
            this.pathParameterSegregator = this.devExURL.split('/:');
            for (let i = 1; i < this.pathParameterSegregator.length; i++) {
                this.pathParameterStopper = this.pathParameterSegregator[i].split('/');
                this.pathParameterSegregator[i] = this.pathParameterStopper[0];
            }
            // {} for calculation
            let temp2 = this.devExURL.split('/');
            // /: append
            this.pathParameter = [];
            for (let i = 1; i < this.pathParameterSegregator.length; i++) {
                this.pathParameterValue = this.pathParameterSegregator[i];
                this.find = true;
                for (let j = 0; j < this.pathParameter.length; j++) {
                    if (this.pathParameterSegregator[i] === this.pathParameter[j]['key']) {
                        this.find = false;
                    }
                }
                if (this.find === true) {
                    this.pathParameter.push({'key': this.pathParameterValue, 'value': '', 'description': ''});
                }
            }
            // {} append
            for (let i = 2; i < temp2.length; i++) {
                const init = temp2[i].indexOf('{');
                const fin = temp2[i].indexOf('}');
                if ((!(this.pathParameter.some(e => e.key === temp2[i].substr(init + 1, fin - init - 1))) && temp2[i].substr(init + 1, fin - init - 1) !== '') && init !== -1 && fin !== -1) {
                    this.pathParameter.push({
                        'key': temp2[i].substr(init + 1, fin - init - 1),
                        'value': '',
                        'description': ''
                    });
                }
            }
            // confirm to show the path parameter area.
            if (this.pathParameter.length !== 0) {
                this.showPathParameters = true;
            } else {
                this.showPathParameters = false;
            }
        }
    }

    checkQueryParams(event) {
        const tempUrl = event.target.value;
        const seperator = tempUrl.split('/');
        let query: any;
        let finalquery: any;
        if (seperator.length > 0) {
            query = seperator[seperator.length - 1].split('?');
            if (query.length > 1) {
                finalquery = query[query.length - 1].split('&');
                if (finalquery) {
                    for (let i = 0; i < finalquery.length; i++) {
                        let temp = finalquery[i].split('=');
                        let flag = false;
                        for (let j = 0; j < this.parameterData.length; j++) {
                            if (temp[0].includes(this.parameterData[j]['key']) || this.parameterData[j]['key'].includes(temp[0]) || this.parameterData[j]['key'] === temp[0]) {
                                flag = true;
                                if (temp.length > 1) {
                                    this.parameterData[j]['key'] = temp[0];
                                    this.parameterData[j]['value'] = temp[1];
                                } else {
                                    this.parameterData[j]['key'] = temp[0];
                                    this.parameterData[j]['value'] = '';
                                }
                            }
                        }
                        if (flag === false) {
                            if (temp.length > 1) {
                                this.parameterData.push({key: temp[0], value: temp[1], description: ''});
                            } else {
                                this.parameterData.push({key: temp[0], value: '', description: ''});
                            }
                        }
                    }
                }
            }
        }
    }


    getEntity(val) {
        const data = val.split('#');
        return data[0];
    }

    getVersion(val) {
        const data = val.split('#');
        return data[1];
    }

    getExecutor() {
        for (let i = 0; i < this.executors.length; i++) {
            for (let j = 0; j < this.executors[i]['executors'].length; j++) {
                if (this.executors[i]['executors'][j]['executor_method_type'] === this.httpOperation && this.executors[i]['executors'][j]['apiUrl'] === this.httpUrl) {
                    this.executor = this.executors[i]['executors'][j];
                }
            }
        }
        if (this.executor) {
            this.headersData = this.executor.headers;
            this.requestBody = this.executor.requestBody;
        }

    }

    getBackgroundStyle(val) {
        if (val === 'GET') {
            return 'get-method';
        } else if (val === 'PUT') {
            return 'put-method';
        } else if (val === 'POST') {
            return 'post-method';
        } else if (val === 'DELETE') {
            return 'delete-method';
        } else {
            return 'get-method';
        }
    }

    getRequestBodyValue(val) {
        switch (val) {
            case 'raw':
                // return JSON.stringify(this.editor.get());
                return this.editor.get();
            case 'binary':
            case 'none':
            default:
        }
    }

    getRequestBody() {
        if (this.requestBodySelected === 'raw') {
            const requestbody = {
                'value': this.getRequestBodyValue(this.requestBodySelected),
                'key': 'payload',
                'description': 'Document in JSON format',
                'annotation': 'RequestBody'
            };
            return requestbody;
        } else if (this.requestBodySelected === 'form-data') {
            const requestbody = {
                'value': this.formData,
                'key': 'payload',
                'description': 'Document in JSON format',
                'annotation': 'RequestBody'
            };
            return requestbody;
        } else if (this.requestBodySelected === 'x-www-form-urlencoded') {
            const requestbody = {
                'value': this.formData,
                'key': 'payload',
                'description': 'Document in JSON format',
                'annotation': 'RequestBody'
            };
            return requestbody;
        } else if (this.requestBodySelected === 'none') {
            const requestbody = null;
            return requestbody;
        }
    }

    toggleExecutor(ev) {
        $('.presteps-executor').slideToggle();
        $(ev.target).toggleClass('fa-chevron-down fa-chevron-up');
        //$('fa').toggleClass('fa-chevron-down fa-chevron-up');
    }

    resetAttributes() {
        this.headersData = [];
        this.requestBody = {};
        this.httpOperation = '';
        this.httpUrl = '';
    }

    hasPreStepsPermissions() {
        if (this.editFlag === true) {
            return this.platform.hasPermissions(['EDIT_PRE_STEPS_TEST_SUITE_API', 'edit_pre_steps:' + this.partner + '=>' + this.account + '=>' + this.executor_name + '=>' + this.executor_version]);
        } else {
            return this.platform.hasPlatformPermission('CREATE_PRE_STEPS_TEST_SUITE_API');
        }
    }

    async executeApi() {
        this.executor['requestBody'] = await this.headerChild.getRequestBody();
        const payload = {
            //'executor_name': this.executor_name,
            'executor_type': 'API',
            //'executor_version': this.executor_version,
            'executor_method_type': this.httpOperation,
            'apiUrl': this.httpUrl,
            'dataroot': null,
            'queryParams': this.parameterData,
            'pathParams': this.pathParameter,
            'headers': this.headersData,
            'requestBody': await this.headerChild.getRequestBody(),
            //'executors': this.executors,
            'prerequisites': null
        };

        //this.onCompletingPreSteps.emit(this.executor);
        this.onCompletingPreSteps.emit(payload);

        this._service.executeApi(payload).subscribe(response2 => {
            this.responses = response2;
            this.responseItems = JSON.stringify(this.responses.body);
        });

        this.resetAttributes();
        this.platform.openSnackBar('Saved successfully', 'Success', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
        });
        //alert('Saved Successfully');


    }


    openDialog() {
        const dialogRef = this.dialog.open(TestCaseNameInputDialog, {
            width: '300px',
            data: {name: '', type: 'pre step'}
        });

        dialogRef.afterClosed().subscribe(response => {
            if (response && response !== '' && response !== ' ') {
                const step = {
                    'executor_name': response,
                    'executor_type': 'API',
                    //'executor_version': this.executor_version,
                    'executor_method_type': '',
                    'apiUrl': '',
                    'dataroot': null,
                    'queryParams': '',
                    'pathParams': '',
                    'headers': '',
                    'requestBody': '',
                    //'executors': this.executors,
                    'prerequisites': ''
                };

                this.preStepsList.push(step);
                this.currentPreStepIndex = this.preStepsList.length - 1;
                if (this.preStepsList.length > 1) {
                    this.resetAttributes();
                }
            }
        });
    }


    onSavingPreSteps(payload) {
        this.onCompletingPreSteps.emit(payload);
    }

    setCurrentPreStep(index) {
        this.headersData = this.preStepsList[index].headers;
        this.prerequisites = this.preStepsList[index].prerequisites;
        this.requestBody = this.preStepsList[index].requestBody;
        this.parameterData = this.preStepsList[index].queryParams;
        this.pathParameter = this.preStepsList[index].pathParams;
        this.responseData = [];
        this.errorMessage = '';
        this.responseError = '';
        this.httpOperation = this.preStepsList[index].executor_method_type;
        this.httpUrl = this.preStepsList[index].apiUrl;
        this.currentPreStepIndex = index;
    }

    onAddingExecutor(payload) {
        const name = this.preStepsList[this.currentPreStepIndex].executor_name;
        this.preStepsList[this.currentPreStepIndex] = payload;
        this.preStepsList[this.currentPreStepIndex]['executor_name'] = name;
    }

}
